// extracted by mini-css-extract-plugin
export default {"layer":"CursorTrail_layer__eESUB","particle":"CursorTrail_particle__Sb1mn","proximityGlow":"CursorTrail_proximityGlow__WIn1O"};